import React from 'react';

import { useTranslation } from 'react-i18next';

import { UiButton } from '@shared/ui';

import cls from './AddtoAllEstimatesBtn.module.css';

interface IAddToAllEstimatesProps {
    onClick: () => void;
}

export const AddToAllEstimatesBtn = ({ onClick }: IAddToAllEstimatesProps) => {
    const { t } = useTranslation();

    return (
        <UiButton
            btnColor="secondary"
            btnText={t('AccessSettingsForm.Modal.AddToEstimates')}
            onClick={onClick}
            className={cls.AddToAllEstimatesBtn}
        />
    );
};
